import { Divider, IconButton } from "@mui/material";
import { Deposit, IdName } from "types";
import SummaryRowTemplate from "./SummaryRowTemplate";
import { openConfirm } from "components/confirmBox";
import DeleteIcon from "@mui/icons-material/Delete";
import styled from "styled-components";

import * as fields from "pages/transactions/depositFieldDefinitions";
import { getMaskedMoneyValue } from "common/functions";

type SummaryRowDepositProps = {
  transaction: Deposit;
  onDeleteClick(): void;
  depositToOptions: IdName[];
  isReadOnlyView: boolean;
};

export default function SummaryRowDeposit(props: SummaryRowDepositProps) {
  const currencyType = props.transaction.currencyType ?? "";
  const toLabel = fields.depositTo.getOptionLabel
    ? fields.depositTo.getOptionLabel(
        props.transaction.to ?? "",
        props.depositToOptions
      )
    : "";
  let transactionAmount = getMaskedMoneyValue(props.transaction.amount ?? 0);

  return (
    <SummaryRowTemplate transaction="Deposit" credit={transactionAmount}>
      <Divider />
      <DetailsRow isBold>
        <TextSection style={{ textAlign: "center" }}>From</TextSection>
        <TextSection style={{ textAlign: "center" }}> To</TextSection>
        <TextSection style={{ textAlign: "center" }}>Amount</TextSection>
      </DetailsRow>
      <Divider />
      <DetailsRow>
        <TextSection>Session Balance</TextSection>
        <TextSection>{toLabel}</TextSection>
        <TextSection style={{ textAlign: "right" }}>
          {`${transactionAmount} ${currencyType.toUpperCase()}`}
        </TextSection>
      </DetailsRow>
      <DetailsRow>
        <TextSection>
          <Spacer />
        </TextSection>
        <TextSection style={{ textAlign: "right" }}>
          <IconButton
            style={{ margin: "-1em 0" }}
            aria-label="delete"
            onClick={() => {
              openConfirm({
                title: "Delete Transaction?",
                description: `Deposit ${transactionAmount} to ${toLabel}`,
                callback: () => {
                  props.onDeleteClick();
                },
              });
            }}
            disabled={props.isReadOnlyView}
          >
            <DeleteIcon />
          </IconButton>
        </TextSection>
      </DetailsRow>
    </SummaryRowTemplate>
  );
}

const TextSection = styled.div`
  min-width: 120px;
  padding: 0px 10px;
`;

const DetailsRow = styled.div<{ isBold?: boolean }>`
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: ${(p) => (p.isBold === true ? "500" : "")};
`;

const Spacer = styled.div`
  flex: 1;
`;
